// components/leads/LeadTransitionDialogs.js
// Dialog per assegnazione tecnico e conferma transizione

import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { User, ArrowRight, XCircle, CheckCircle, Loader2 } from 'lucide-react';

// Assign Technician Modal
export const AssignTechnicianModal = ({
  open,
  onOpenChange,
  technicians,
  selectedTechnician,
  setSelectedTechnician,
  transitionNote,
  setTransitionNote,
  onAssign,
  transitioning,
  leadId
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-md">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <User className="w-5 h-5 text-[#FF7819]" />
          Assegna Tecnico
        </DialogTitle>
        <DialogDescription>
          Seleziona il tecnico a cui assegnare questo lead
        </DialogDescription>
      </DialogHeader>
      
      <div className="py-4 space-y-4">
        <Select value={selectedTechnician} onValueChange={setSelectedTechnician}>
          <SelectTrigger data-testid="technician-select">
            <SelectValue placeholder="Seleziona tecnico..." />
          </SelectTrigger>
          <SelectContent>
            {technicians.map(tech => (
              <SelectItem key={tech.id} value={tech.id}>
                {tech.first_name} {tech.last_name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <div>
          <Label className="text-sm">Note (opzionale)</Label>
          <Textarea
            placeholder="Aggiungi note per il tecnico..."
            value={transitionNote}
            onChange={(e) => setTransitionNote(e.target.value)}
            className="mt-1"
            data-testid="assign-notes-textarea"
          />
        </div>
      </div>

      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>
          Annulla
        </Button>
        <Button
          onClick={() => onAssign(leadId, 'assegnato', selectedTechnician)}
          disabled={!selectedTechnician || transitioning}
          className="bg-[#FF7819] hover:bg-[#E56A10]"
          data-testid="confirm-assign-btn"
        >
          {transitioning ? (
            <>
              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              Assegnazione...
            </>
          ) : (
            <>
              <CheckCircle className="w-4 h-4 mr-2" />
              Assegna
            </>
          )}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

// Transition Confirmation Modal
export const TransitionConfirmModal = ({
  open,
  onOpenChange,
  transitionData,
  transitionNote,
  setTransitionNote,
  onConfirm,
  transitioning
}) => (
  <Dialog open={open} onOpenChange={() => onOpenChange(null)}>
    <DialogContent className="sm:max-w-md">
      {transitionData && (
        <>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              {transitionData.action.isNegative ? (
                <XCircle className="w-5 h-5 text-red-500" />
              ) : (
                <ArrowRight className="w-5 h-5 text-[#FF7819]" />
              )}
              {transitionData.action.label}
            </DialogTitle>
            <DialogDescription>
              {transitionData.action.isNegative 
                ? `Sei sicuro di voler segnare questo lead come "${transitionData.action.label}"?`
                : `Conferma il passaggio allo stato "${transitionData.action.label}"`
              }
            </DialogDescription>
          </DialogHeader>

          <div className="py-4">
            <Label className="text-sm">Note (opzionale)</Label>
            <Textarea
              placeholder="Aggiungi note sulla transizione..."
              value={transitionNote}
              onChange={(e) => setTransitionNote(e.target.value)}
              className="mt-1"
              data-testid="transition-notes-textarea"
            />
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => onOpenChange(null)}>
              Annulla
            </Button>
            <Button
              onClick={() => onConfirm(transitionData.lead.id, transitionData.action.status)}
              disabled={transitioning}
              className={transitionData.action.isNegative 
                ? 'bg-red-500 hover:bg-red-600' 
                : 'bg-[#FF7819] hover:bg-[#E56A10]'
              }
              data-testid="confirm-transition-btn"
            >
              {transitioning ? (
                <>
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  Conferma...
                </>
              ) : (
                <>
                  <CheckCircle className="w-4 h-4 mr-2" />
                  Conferma
                </>
              )}
            </Button>
          </DialogFooter>
        </>
      )}
    </DialogContent>
  </Dialog>
);
